// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error_wrapper__3XO5T","header":"Error_header__31RQB","message":"Error_message__2tRMK","stack":"Error_stack__C226p","buttons":"Error_buttons__xI9VD"};